var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGymFW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6597 18.3955C21.7215 18.0987 22.8392 17.931 24.0003 17.931C25.1603 17.931 26.2792 18.0987 27.3409 18.3955C29.1569 17.6518 30.286 16.3729 30.286 15.1723C30.286 13.3461 27.7043 11.3103 24.0003 11.3103C20.2963 11.3103 17.7146 13.3461 17.7146 15.1723C17.7146 16.3729 18.8437 17.6518 20.6597 18.3955Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 29.5172C12 34.1583 14.8331 38.1506 18.9143 40H29.0857C33.1669 38.1506 36 34.1583 36 29.5172C36 25.6486 34.0286 22.2323 31.0126 20.128C32.6823 18.8403 33.7143 17.0968 33.7143 15.1724C33.7143 11.211 29.3646 8 24 8C18.6354 8 14.2857 11.211 14.2857 15.1724C14.2857 17.0968 15.3177 18.8403 16.9874 20.128C13.9714 22.2323 12 25.6486 12 29.5172Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2859 29.5173C14.2859 26.9331 15.3682 24.5926 17.119 22.8966",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymFW);
export default __webpack_public_path__ + "static/media/gymF-w.dca1de10c9093f0803cbc2874d3ba194.svg";
export { ForwardRef as ReactComponent };